<div style="display: flex; align-items: center; justify-content: center; height: 75vh">
    <div style="display: flex; flex-direction: column; align-items: center">
        <p>Enter the 6-digit code from Google Authenticator or Authy mobile app.</p>
        <input nz-input type="text" [(ngModel)]="token" style="width: 120px">
        <button nz-button nzType="primary" (click)="authenticate()" style="margin-top: 10px">Authenticate</button>
    </div>
</div>
